export default __webpack_public_path__ + "static/media/milestone 2800.96a97a3d.svg";